import React from "react";

const AmountNormalization = ({ row }) => {
  return <div>{row?.amount?.toLocaleString()}</div>;
};

export default AmountNormalization;
